import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class BrandDto extends BaseEntityDto {
  name: string;

  toString(): string {
    return this.name;
  }
}
